
import './modules/mobilemenu.js';
import './modules/hDropdown.js';
import './modules/acceptCookie.js';
import './modules/language.js';
import './modules/loadingspinner.js';
import './modules/forms.js';

import './views/product/resulttable.js';
import './views/checkout/checkout.js';